import React from "react";

import { Icon, WrappingIconProps } from "../Icon";

export const SortUpIcon = (props: WrappingIconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.6 9.2C12.2 9.6 11.6 9.6 11.2 9.2C10.8 8.9 10.8 8.2 11.3 7.8L14.8 4.3C15 4.1 15.3 4 15.5 4C15.7 4 16 4.1 16.1 4.3L19.6 7.8C20 8.2 20 8.8 19.6 9.2C19.2 9.6 18.6 9.6 18.2 9.2L16.4 7.4V15.3C16.4 15.9 16 16.3 15.4 16.3C14.8 16.3 14.4 15.9 14.4 15.3V7.4L12.6 9.2ZM9.40001 15.8C9.80001 15.4 10.4 15.4 10.8 15.8C11.2 16.1 11.2 16.8 10.7 17.2L8.20001 19.7C8.00001 19.9 7.70001 20 7.50001 20C7.30001 20 7.00001 19.9 6.90001 19.7L4.40001 17.2C4.00001 16.8 4.00001 16.2 4.40001 15.8C4.80001 15.4 5.40001 15.4 5.80001 15.8L6.60001 16.6V12.7C6.60001 12.1 7.00001 11.7 7.60001 11.7C8.20001 11.7 8.60001 12.1 8.60001 12.7V16.6L9.40001 15.8Z"
      />
    </Icon>
  );
};
